// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"100e6774","787":"b05ca5f2"}[chunkId] + ".chunk.js";
};